<template>
  <v-container fluid>
    <!--<h1 class="headline mb-1">Planes adquiridos</h1>-->
    <v-expansion-panels
      v-model="panel_planes"
      popout
      inset
      focusable
      multiple
      >
      <template v-for="(planes_, i) in array_planes">
        <v-expansion-panel>
            <v-expansion-panel-header class="text-h4">
                Plan: <!--{{planes_.planId}} - --> {{planes_.nombre_plan}} - {{planes_.estado}}
            </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card-title class="text-center">Detalle de la compra:</v-card-title>
            <ul>
              <li>Vigencia desde/hasta: {{planes_.vigencia_desde_formateada}} {{planes_.vigencia_hasta_formateada}}</li>
              <li>Vigencia hasta: {{planes_.vigencia_hasta_formateada}}</li>
              <li>Estado: {{planes_.estado}}</li>
            </ul>

            <v-row>
            <v-col cols="12" md="4">
              <v-card class="text-center">
                <v-card-title>
                  Certificados
                </v-card-title>
                <v-card-text>
                  <p class="display-3">
                    {{ validarValor(planes_.certificados_adquirido) }}
                  </p>
                  <p>Utilizados: {{ validarValor(planes_.certificados_utilizado) }} </p>
                  <v-progress-linear
                    height="20"
                    :color="porcentajeColor(planes_.certificados_adquirido,planes_.certificados_utilizado)"
                    :value="porcentajeValor(planes_.certificados_adquirido,planes_.certificados_utilizado)"
                    striped
                  >
                    <strong>{{ porcentajeValor(planes_.certificados_adquirido,planes_.certificados_utilizado) }}%</strong>
                  </v-progress-linear>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="text-center">
                <v-card-title>
                  Operadores
                </v-card-title>
                <v-card-text>
                  <p class="display-3">
                    {{ validarValor(planes_.operador_adquirido) }}
                  </p>
                  <p>Utilizados: {{ validarValor(planes_.operador_utilizado) }} </p>
                  <v-progress-linear
                    height="20"
                    :color="porcentajeColor(planes_.operador_adquirido,planes_.operador_utilizado)"
                    :value="porcentajeValor(planes_.operador_adquirido,planes_.operador_utilizado)"
                    striped
                  >
                    <strong>{{ porcentajeValor(planes_.operador_adquirido,planes_.operador_utilizado) }}%</strong>
                  </v-progress-linear>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="text-center">
                <v-card-title>
                  Estampados
                </v-card-title>
                <v-card-text>
                  <p class="display-3">
                    {{ validarValor(planes_.estampado_anual_adquirido) }}
                  </p>
                  <p>Utilizados: {{ validarValor(planes_.estampado_anual_utilizado) }} </p>
                  <v-progress-linear
                    height="20"
                    :color="porcentajeColor(planes_.estampado_anual_adquirido,planes_.estampado_anual_utilizado)"
                    :value="porcentajeValor(planes_.estampado_anual_adquirido,planes_.estampado_anual_utilizado)"
                    striped
                  >
                    <strong>{{ porcentajeValor(planes_.estampado_anual_adquirido,planes_.estampado_anual_utilizado) }}%</strong>
                  </v-progress-linear>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="text-center">
                <v-card-title>
                  Administradores
                </v-card-title>
                <v-card-text>
                  <p class="display-3">
                    {{ validarValor(planes_.admin_adquirido) }}
                  </p>
                  <p>Utilizados: {{ validarValor(planes_.admin_utilizado) }} </p>
                  <v-progress-linear
                    height="20"
                    :color="porcentajeColor(planes_.admin_adquirido,planes_.admin_utilizado)"
                    :value="porcentajeValor(planes_.admin_adquirido,planes_.admin_utilizado)"
                    striped
                  >
                    <strong>{{ porcentajeValor(planes_.admin_adquirido,planes_.admin_utilizado) }}%</strong>
                  </v-progress-linear>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="text-center">
                <v-card-title>
                  Flujos
                </v-card-title>
                <v-card-text>
                  <p class="display-3">
                    {{ validarValor(planes_.flujos_adquirido) }}
                  </p>
                  <p>Utilizados: {{ validarValor(planes_.flujos_utilizado) }} </p>
                  <v-progress-linear
                    height="20"
                    :color="porcentajeColor(planes_.flujos_adquirido,planes_.flujos_utilizado)"
                    :value="porcentajeValor(planes_.flujos_adquirido,planes_.flujos_utilizado)"
                    striped
                  >
                    <strong>{{ porcentajeValor(planes_.flujos_adquirido,planes_.flujos_utilizado) }}%</strong>
                  </v-progress-linear>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="text-center">
                <v-card-title>
                  Plantillas
                </v-card-title>
                <v-card-text>
                  <p class="display-3">
                    {{ validarValor(planes_.plantillas_adquirido) }}
                  </p>
                  <p>Utilizados: {{ validarValor(planes_.plantillas_utilizado) }} </p>
                  <v-progress-linear
                    height="20"
                    :color="porcentajeColor(planes_.plantillas_adquirido,planes_.plantillas_utilizado)"
                    :value="porcentajeValor(planes_.plantillas_adquirido,planes_.plantillas_utilizado)"
                    striped
                  >
                    <strong>{{ porcentajeValor(planes_.plantillas_adquirido,planes_.plantillas_utilizado) }}%</strong>
                  </v-progress-linear>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
    </v-expansion-panels>
  </v-container>
</template>
<script>
import axios from "axios";
  
export default {
  components: { 

  },
  data: function() {
    return {
      panel: [],
      panel_planes: [],
      array_planes: [],
      indeterminate: false,
    };
  },
  computed: {

  },
  mounted() {
      console.log("PlanesAdquiridos.vue");
    this.getPlanesAdquiridos();
  },
  methods: {
    getPlanesAdquiridos() {
      let getPlanes = axios.post('Agrupador/listar_planes_adquiridos', { "Id": this.$route.params.id }, { 'headers': this.$store.state.user.headers });
      return getPlanes.then((callback) =>
      {
        this.array_planes = callback.data;
      }).catch((error) => {
        console.log("ERROR EN EL CALLBACK" + error);
      });
    },
    activarCompra(recarga){
      recarga.loading = true;
      let postcompra = axios.post('Compra/Activar', { "compra_detalle_id" : recarga.id }, { 'headers': this.$store.state.user.headers })
      return postcompra.then((callback) => {
        recarga.loading = false;
        recarga.estado = 'ACTIVO';
        console.log(callback);
      }).catch((error) => {
        recarga.loading = false;
        this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: error.response.data });
      });
    },
    porcentajeValor(valor_neto, valor_utilizado){

      if (valor_neto == 0 && valor_utilizado == 0) {
        return 0;
      }

      let porcentaje = ((valor_utilizado * 100) / valor_neto);

      if (porcentaje % 1 === 0) {
        return porcentaje
      } else {
        return porcentaje.toFixed(2);
      }

    },
    porcentajeColor(valor_neto, valor_utilizado){
      let color = 'black';

      if (valor_neto == 0 && valor_utilizado == 0) {
        return color;
      }

      let valor = (valor_utilizado * 100) / valor_neto;

      if(valor >=0 && valor <=50 ) {
        color = 'green';
      }
      if(valor >=51 && valor <=80 )  {
       color = 'warning'; 
      }
      if(valor >=81 && valor <=100 )  {
        color = 'red'; 
      }
      //console.log("valor_neto: " + valor_neto + " valor_utilizado: " + valor_utilizado + " valor: " + valor + " color: " + color);
      return color;
    },
    validarValor(value) {
      let val = value; 
      if(value > 999 && value < 1000000) {
        val = (value / 1000) + "k";
      }
      if(value > 1000 && value > 1000000) {
        val = (value / 1000000) + "M";
      }
      return val;
    }
  },
};
</script>